import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { EvaluadosDto } from 'src/app/dto/evaluados-dto';
import { PersonaDto } from 'src/app/dto/persona-dto';
import { CursoService } from 'src/app/services/curso.service';
import { EvaluarDocentexDocenteService } from 'src/app/services/evaluar-docentex-docente.service';
import { PersonaService } from 'src/app/services/persona.service';
import { VerificacionService } from 'src/app/services/verificacion.service';
import { CuestionarioComponent } from '../cuestionario/cuestionario.component';
import { DocentesDependenciaUaaDto } from 'src/app/dto/docentes-dependencia-uaa-dto';
import { HttpErrorResponse } from '@angular/common/http';
import { EvaluacionService } from 'src/app/services/evaluacion.service';
import { RespuestaEvaluadoComponent } from '../respuesta-evaluado/respuesta-evaluado.component';

@Component({
  selector: 'app-docente-par',
  templateUrl: './docente-par.component.html',
  styleUrls: ['./docente-par.component.css']
})
export class DocenteParComponent implements OnInit {

  data: PersonaDto = new PersonaDto;
  GrupoUid: number;
  uaaCodigo: number;
  ocultar: boolean = true; // Inicialmente, el botón está oculto
  califica: boolean = false;
  evaluados: EvaluadosDto[];
  docentesEvaluados: EvaluadosDto[];
  decano: boolean = false;
  docentePar: PersonaDto[];
  evaluar = false;
  url: String = 'https://gaitana.usco.edu.co/evadoc';
  jefes: DocentesDependenciaUaaDto[];
  docente: boolean = false;

  constructor(
    public dialog: MatDialog,
    private validadroService: VerificacionService,
    private rutaActiva: ActivatedRoute,
    private personaService: PersonaService,
    private cursoService: CursoService,
    private EvaluarDocentexDocente: EvaluarDocentexDocenteService,
    private evaluacionService: EvaluacionService
  ) { }

  ngOnInit() {
    this.validadroService.validarSiTieneToken();
    this.GrupoUid = this.rutaActiva.snapshot.params.grupo;
    this.uaaCodigo = this.rutaActiva.snapshot.params.uaa;
    this.datosPersonales();
  }

  datosPersonales() {
    this.personaService.datosPersonales().subscribe(data => {
      this.data = data;
      if (this.data.periodo && this.data.periodo.codigo) {
        this.personaService.getPeriodo(this.data.periodo.codigo).subscribe(nombre => {
          this.data.periodo.nombre = nombre;
        });
      }
      if (this.GrupoUid == 2) {
        this.docente = true;
        this.casoDocente(data.periodo.codigo);
      } else {
        this.casoDecano();
      }

    });
  }

  casoDocente(periodo: number) {
    if (!this.decano) {
      this.EvaluarDocentexDocente.obtenerDocentesxDocentes().subscribe((data: PersonaDto[]) => {
        this.docentePar = data;
        this.evaluar = false;
        this.ObtenerDocentesParEvaluado(periodo);
      });
    }
  }

  ObtenerDocentesParEvaluado(periodo: number) {
    let tipo2 = this.GrupoUid;
    let periodo2 = periodo;

    if (this.data != null) {
      this.cursoService.ObtenerDocentesEvaluados(tipo2, periodo2).subscribe((data: EvaluadosDto[]) => {
        this.docentesEvaluados = data;
        this.ocultar = false;

        if (this.GrupoUid == 2 && this.docentePar) {
          const allEvaluated = this.docentePar.every(docente =>
            this.docentesEvaluados.some(evaluado => evaluado.docente === docente.persona.codigo)
          );
          this.evaluacionService.setDocentesEvaluados(allEvaluated);
        } else {
          this.evaluacionService.setDocentesEvaluados(true);
        }
      });
    }
  }

  isDocenteEvaluado(docente: PersonaDto): boolean {
    if (!this.docentesEvaluados) {
      this.califica = false;
      return false;
    }
    const evaluado = this.docentesEvaluados.some(evaluado => evaluado.docente === docente.persona.codigo);
    this.califica = evaluado;
    return evaluado;
  }


  openDialogDocentes(item: PersonaDto) {
    const dialogRef = this.dialog.open(CuestionarioComponent, {
      maxWidth: '95vw',
      width: '950px',
      maxHeight: '90vh',
      data: {
        uid: this.GrupoUid,
        periodo: this.data.periodo.codigo,
        docente: item.persona.codigo,
        curso: null,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ObtenerDocentesParEvaluado(this.data.periodo.codigo);
    });
  }

  dialogRespuestasPar(docente: any) {

    const dialogRef = this.dialog.open(RespuestaEvaluadoComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      data: {
        item: true,
        evaluados: this.docentesEvaluados,
        evaluadoDocente: docente,
        evaluadoCurso: 0
      },
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  casoDecano() {
    this.personaService.getJefes(Number(this.uaaCodigo)).subscribe(data => {
      this.jefes = data;
      this.obtenerEvaluadosDecano();
    }, (err: HttpErrorResponse) => console.log('error' + err))
  }

  //DECANO
  obtenerEvaluadosDecano() {
    let tipo = 3
    let periodo2 = this.data.periodo.codigo;
    if (this.data != null) {
      this.cursoService.ObtenerDocentesEvaluados(tipo, periodo2).subscribe((data: EvaluadosDto[]) => {
        this.docentesEvaluados = data;
        this.ocultar = false;

        if (this.GrupoUid == 3 && this.jefes) {
          const allEvaluated = this.jefes.every(jefe =>
            this.docentesEvaluados.some(evaluado => evaluado.docente === jefe.codigoPersona)
          );
          this.evaluacionService.setDocentesEvaluados(allEvaluated);
        } else {
          this.evaluacionService.setDocentesEvaluados(true);
        }
      });
    }
  }

  isJefeEvaluado(jefe: DocentesDependenciaUaaDto): boolean {
    if (!this.docentesEvaluados) {
      this.califica = false;
      return false;
    }
    const evaluado = this.docentesEvaluados.some(evaluado => evaluado.docente === jefe.codigoPersona);
    this.califica = evaluado;
    return evaluado;
  }

  openDialogDecano(jefe: DocentesDependenciaUaaDto) {
    const dialogRef = this.dialog.open(CuestionarioComponent, {
      maxWidth: '95vw',
      width: '950px',
      maxHeight: '90vh',
      data: {
        uid: this.GrupoUid,
        periodo: this.data.periodo.codigo,
        docente: jefe.codigoPersona,
        curso: null,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.obtenerEvaluadosDecano();
    });
  }

  dialogRespuestasDecano(docente: any) {

    const dialogRef = this.dialog.open(RespuestaEvaluadoComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      data: {
        item: true,
        evaluados: this.docentesEvaluados,
        evaluadoDocente: docente.codigoPersona,
        evaluadoCurso: 0
      },
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
}
